import React from 'react';

import Alert from '@material-ui/lab/Alert';
import Skeleton from '@material-ui/lab/Skeleton';
import Box from '@material-ui/core/Box';

import ModelFilter from 'components/ModelFilter';
import SidebarRqModel from 'components/SidebarRqModel';
import { SHOW_REQUEST_MODEL } from '@constants';
import useLocal from 'localization';
import { isLoggedIn } from 'core/modules/auth.utils';

import Props, { allModelId, industryModelsId, myModelId } from './types';
import { History } from 'core';
import routes from 'components/Router/routes';
import useStyles from './style';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { Badge } from '@material-ui/core';
import clsx from 'clsx';

const ModelSidebar: React.FC<Props> = ({
  sectorList,
  hasSectorError,
  sectorError,
  isSectorLoading,
  selectFilter,
  selectedSector,
  isFreeTier,
  allowedSectors,
  isEnterpriseTier,
  isTrialTier
}: Props) => {
  const industryTitle = useLocal('industries');
  const subscribed = useLocal('subscribed');
  const allModel = useLocal('all_model');
  const industryModel = useLocal('industry_model');
  const classes = useStyles();
  const extraFilter = isLoggedIn()
    ? [
        { name: subscribed, id: myModelId, isProtected: true },
        { name: allModel, id: allModelId }
      ]
    : [{ name: allModel, id: allModelId }];
  const newText = useLocal('new');
  return (
    <Box
      position={{ md: 'fixed', lg: 'fixed', xl: 'fixed' }}
      width={{ md: '15vw', lg: '15vw', xl: '20em' }}
      data-testid="sector-list"
    >
      {isSectorLoading && (
        <>
          {[...Array(16)].map((data, index) => (
            <Skeleton key={`sidebar-skeleton-${data}-${index}`} height={33.2} />
          ))}
        </>
      )}
      {hasSectorError && <Alert severity="error">{sectorError}</Alert>}
      {sectorList?.length && (
        <ModelFilter
          title={industryTitle}
          selectFilter={selectFilter}
          seletedFilterId={selectedSector}
          isFreeTier={isFreeTier}
          allowedSectors={allowedSectors}
          showIcon
          list={[...extraFilter, ...sectorList]}
          key="IndustryFilter"
        />
      )}

      {(isTrialTier || isEnterpriseTier) && !isSectorLoading && (
        <Badge
          color={'error'}
          classes={{ root: classes.badgeRoot, anchorOriginTopRightRectangle: classes.newBadge }}
          badgeContent={newText}
          className={classes.industryModelItem}
        >
          <ListItem
            onClick={() => {
              selectFilter(industryModelsId);
            }}
            disableGutters
            dense
            className={clsx(classes.listText, {
              [classes.selectedText]: selectedSector === industryModelsId
            })}
            button
          >
            {industryModel}
            <ListItemIcon className={classes.icon}>
              <ArrowRightIcon />
            </ListItemIcon>
          </ListItem>
        </Badge>
      )}

      {SHOW_REQUEST_MODEL && <SidebarRqModel key="SidebarRqModel" />}
    </Box>
  );
};

export default React.memo(ModelSidebar);
